import { get } from "../../../shared/data";

export const getSettings = () => {
    return get("/app-settings");
};

export const getPermissions = () => {
    return get("/users/context");
};
